// Nova Sonic Portal Configuration - Auto-generated by deploy.sh
// STACK: NovaSonicIsvDemoFrontendStack

const CONFIG = {
  // API Configuration
  apiUrl: "https://api.novasonicdemos.studio/",
  
  // WebSocket Configuration  
  wsUrl: "wss://messages.novasonicdemos.studio",
  
  // Cognito Configuration
  cognito: {
    userPoolId: "us-east-1_fVVjzI02c",
    clientId: "30gdfpd5q2614jnujcev3lvdlc",
    region: "us-east-1",
    domain: "https://nova-sonic-isv-demo-portal-dev.auth.us-east-1.amazoncognito.com",
    callbackUrl: "https://novasonicdemos.studio",
    logoutUrl: "https://novasonicdemos.studio",
  },
};

export default CONFIG;
